import { AccountInput } from 'src/legacy_graphql'
import { useActions, useCallback, useMutations } from '.'

const useUpdateAccount = () => {
  const actions = useActions()
  const mutations = useMutations()
  return useCallback(
    async (account: AccountInput & { profileImageUrl?: string }) => {
      const { profileImageUrl, ...acct } = account

      try {
        const save = async () =>
          (await mutations.updateAccount({ account: acct })).updateAccount
            .account

        const savedAccount = await save()

        actions.updatedAccount(savedAccount)
      } catch (error) {
        console.error(error)
      }
    },
    [actions, mutations],
  )
}

export default useUpdateAccount
